import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token';
const tenKey = 'X-Tenant-ID'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getTenant() {
  return Cookies.get(tenKey)
}

export function setTenant(tenId) {
  return Cookies.set(tenKey, tenId)
}

export function removeTenant() {
  return Cookies.remove(TokenKey)
}